export const TEACHER_DASHBOARD_NAVIGATION_TAG_NAME =
  "teacher_dashboard_navigation_enabled";
export const TEACHER_DASHBOARD_REPORTING_TITLE_TAG_NAME =
  "teacher_dashboard_reporting_title";
export const TEACHER_DASHBOARD_REPORTING_SUBHEADING_TAG_NAME =
  "teacher_dashboard_reporting_subheading";
export const TEACHER_DASHBOARD_NAVIGATION_ELEMENT_TYPE =
  "teacher_dashboard_navigation";

export const TEACHER_DASHBOARD_NAVIGATION_ITEMS = [
  { number: 1, id: "home", label: "Home", locked: true },
  { number: 2, id: "admin", label: "Classrooms" },
  { number: 3, id: "assign-screener", label: "Assign Screener" },
  { number: 4, id: "before-screening", label: "Before Screening" },
  { number: 5, id: "student-qrs", label: "Student QRs" },
  { number: 6, id: "results", label: "Results" },
  {
    number: 7,
    id: "reporting",
    label: "Reporting",
    reportingConfig: true,
    defaultTitle: "Reporting",
    defaultSubheading:
      "Use these tools to understand the children joining your class and to continue recording observations as they progress through the year.",
  },
  {
    number: "7.1",
    id: "new-class-insights",
    label: "New Class Insights",
    parentId: "reporting",
    reportingConfig: true,
    defaultTitle: "New Class Insights",
    defaultSubheading:
      "Summarises a pupil's transition into the current class using the saved End of Year report from ALPACA and staff notes from the previous school year.",
  },
  {
    number: "7.2",
    id: "screening-point-report",
    label: "Screening Point Report",
    parentId: "reporting",
    reportingConfig: true,
    defaultTitle: "Screening Point Report",
    defaultSubheading:
      "Generate a report for a single screening point, using the pupil's completed screener for that point.",
  },
  {
    number: "7.3",
    id: "parent-teacher-meeting",
    label: "Parent Teacher Meeting",
    parentId: "reporting",
    reportingConfig: true,
    defaultTitle: "Parent Teacher Meeting",
    defaultSubheading:
      "Generate a parent-facing handout for a PTM, using the pupil's completed screeners for the year.",
  },
  {
    number: "7.4",
    id: "eoy-report-assistant",
    label: "End of Year Report Assistance",
    parentId: "reporting",
    reportingConfig: true,
    defaultTitle: "End of Year Report Assistance",
    defaultSubheading:
      "Generate or review End-of-Year reports from the previous school year.",
  },
  {
    number: "7.5",
    id: "classroom-handover",
    label: "Classroom Observations",
    parentId: "reporting",
    reportingConfig: true,
    defaultTitle: "Classroom Observations",
    defaultSubheading:
      "Review and continue recording classroom observations for pupils in your class.",
  },
  { number: 8, id: "aladdin-export", label: "Aladdin Export" },
  { number: 9, id: "sandbox", label: "Sandbox" },
];

export const TEACHER_DASHBOARD_REPORTING_ITEMS =
  TEACHER_DASHBOARD_NAVIGATION_ITEMS.filter((item) => item.reportingConfig);
